import request from '@shared/api/request';
import {
    API_AUTO_TEST_RESULTS_PATH,
    API_BRANCHES,
    API_BUILDS,
    API_HAND_TEST_RESULTS_PATH,
    API_TEST_RESULTS_PATH,
    API_TEST_RUN_PATH,
} from '@shared/constants/pathsConstants';

export function getTestRuns(params) {
    return request.get(`/${API_TEST_RUN_PATH}/`, { params });
}

export function getTestRunById(id) {
    return request.get(`/${API_TEST_RUN_PATH}/${id}/`);
}

export function getTestResults(params) {
    return request.get(`/${API_TEST_RESULTS_PATH}/`, { params });
}

export function patchTestRun(id, data) {
    return request.patch(`/${API_TEST_RUN_PATH}/${id}/`, data);
}

export function editHandtestResult(id, data) {
    return request.patch(`/${API_HAND_TEST_RESULTS_PATH}/${id}/`, data);
}

export function patchTestRunResult(id, data, isHandtest) {
    return request.patch(`/${isHandtest ? API_HAND_TEST_RESULTS_PATH : API_AUTO_TEST_RESULTS_PATH}/${id}/`, data);
}

export function getTestResultById(id, isHandtest) {
    return request.get(`/${isHandtest ? API_HAND_TEST_RESULTS_PATH : API_AUTO_TEST_RESULTS_PATH}/${id}/`);
}

export function getTestResultBuildsFilter(params) {
    return request.get(`/${API_TEST_RESULTS_PATH}/${API_BUILDS}/`, { params });
}

export function getTestResultBranchesFilter(params) {
    return request.get(`/${API_TEST_RESULTS_PATH}/${API_BRANCHES}/`, { params });
}

export function getTestRunsBuildsFilter() {
    return request.get(`/${API_TEST_RUN_PATH}/${API_BUILDS}/`);
}

export function getTestRunsBranchesFilter() {
    return request.get(`/${API_TEST_RUN_PATH}/${API_BRANCHES}/`);
}

export function getTestResultsByTestcase({ autotests, handtests }) {
    return request.post(`/${API_TEST_RESULTS_PATH}/`, { auto_tests: autotests, hand_tests: handtests });
}
